<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="list.title" placeholder="搜索通知标题" @search="onSearch"></van-search>
		</van-sticky>

		<van-list
			id="notice_list"
			v-model="list.loading"
			:finished="list.finished"
			finished-text="没有更多了"
			@load="onLoad"
			style="padding-bottom: 15px;"
		>
			<van-panel
				v-for="(item, index) in dataList"
				:key="index"
				:title="item.notice_title"
				:status="item.create_date"
			>
				<div>
					<div class="panel-text">{{item.notice_content}}</div>
					<div class="panel-file">
						<div class="file-body" v-for="(item, index) in item.file_list" :key="index">
							<div class="file-body-item">
								<div class="img-body" v-if="isTypeImage(item.file_type)">
									<van-image
										width="100"
										height="100"
										:src="fileUrl+item.file_id"
										@click="imgLook(fileUrl+item.file_id)"
									/>
								</div>
								<div class="img-body" v-else @click="clickFile">
									<i class="file-icon van-icon-description"></i>
									<div class="file-name">{{item.file_name}}.{{item.file_type}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-panel>
		</van-list>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { post } from "@/api/post";
import { Toast } from "vant";
import global_url from "@/utils/global";
import { isImage } from "@/utils/tool";
import { ImagePreview } from "vant";

export default {
	components: {
		navbar
	},
	data() {
		return {
			title: "历史通知",
			list: {
				requestType: "home_notice_list",
				loading: false,
				finished: false,
				page: 1,
				limit: 15,
				title: ""
			},
			dataList: [],
			fileUrl: this.findUrl()
		};
	},
	methods: {
		onLoad() {
			post(this.list)
				.then(response => {
					if (response.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.list.page != 1) {
						this.dataList = this.dataList.concat(response.obj.rows);
					} else {
						this.dataList = response.obj.rows;
					}

					this.list.page += 1;
					this.list.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast("数据异常");
				});
		},
		onSearch() {
			this.list.finished = false;
			this.list.page = 1;
			this.onLoad();
		},
		imgLook(url) {
			ImagePreview({
				images: [url]
			});
		},
		clickFile() {
			return Toast.fail("暂不支持该文件查看");
		},
		isTypeImage(name) {
			return isImage(name);
		},
		findUrl() {
			return global_url.fileUrl;
		}
	}
};
</script>

<style lang="scss">
#notice_list {
	.van-panel__header-value {
		color: #323233;
	}

	.van-panel__content {
		padding: 18px;
		font-size: 12px;
	}

	.van-cell {
		justify-content: space-between;
	}

	.van-cell__value {
		font-size: 12px;
		flex-shrink: 0;
	}

	.van-cell__title,
	.van-cell__value {
		flex: initial;
	}
}

.panel-file {
	overflow: hidden;
	margin-top: 8px;
}

.file-body {
	float: left;
	margin-left: 15px;
	&:nth-child(3n-2) {
		margin-left: 0;
	}
}
</style>
